import _extends from "@babel/runtime/helpers/esm/extends";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import { Components as DropdownFilterComponents } from './filterBar.style';
import React, { useEffect, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import { Components as DropdownWithButton } from './dropdownWithButton.style';
import Icon from '../../Icon';
function DropdownFilter(_ref) {
  let {
    id,
    options,
    selectedFilter,
    onChange,
    onDelete
  } = _ref;
  const [query, setQuery] = useState(selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filter_title);
  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const [computedOptions, setComputedOptions] = useState(options);
  useEffect(() => {
    setComputedOptions(query ? options.filter(option => {
      var _a;
      return (_a = option.filter_title) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().match(query.toLowerCase());
    }) : options);
  }, [query]);
  useEffect(() => {
    if (selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filter_title) {
      setQuery(selectedFilter.filter_title);
    }
  }, [selectedFilter]);
  const dropdownMenuRef = React.useRef(null);
  const onClickShowOptions = () => {
    setIsOptionsOpen(true);
    setQuery('');
  };
  const onClickOutsideHideOptions = () => {
    setIsOptionsOpen(false);
    setQuery(selectedFilter === null || selectedFilter === void 0 ? void 0 : selectedFilter.filter_title);
  };
  const filterFunction = event => {
    const element = event.target;
    setQuery(element.value);
    setIsOptionsOpen(true);
  };
  const onItemDelete = deleteSelectedItem => {
    onChange(deleteSelectedItem);
    onDelete(deleteSelectedItem === null || deleteSelectedItem === void 0 ? void 0 : deleteSelectedItem.filter_title);
  };
  const onSelect = selectedItem => {
    onChange(selectedItem);
    onClickOutsideHideOptions();
  };
  useOnClickOutside(dropdownMenuRef, onClickOutsideHideOptions);
  return _jsxs(DropdownWithButton.DropdownWrapper, _extends({
    id: id,
    onClick: onClickShowOptions,
    ref: dropdownMenuRef
  }, {
    children: [_jsxs(DropdownWithButton.DropdownContainer, {
      children: [_jsx(DropdownWithButton.DropdownInput, {
        id: "searchableSelectWithButtonInOptions-input",
        type: "text",
        placeholder: "Select saved filters",
        value: query,
        onChange: event => {
          filterFunction(event);
        }
      }), _jsx(Icon, {
        name: isOptionsOpen ? 'chevron-up' : 'chevron-down'
      })]
    }), isOptionsOpen && _jsx(DropdownWithButton.DropdownOptionsContainer, {
      children: computedOptions.map((item, index) => _jsx(DropdownWithButton.DropdownOptions, _extends({
        onClick: e => {
          e.stopPropagation();
          onSelect(item);
        }
      }, {
        children: _jsxs(DropdownWithButton.DropdownOption, {
          children: [_jsx(DropdownWithButton.DropdownOptionContent, {
            children: item.filter_title
          }), _jsx(Icon, {
            name: "trash",
            size: "20",
            onClick: () => onItemDelete(item)
          })]
        })
      }), index))
    }), isOptionsOpen && computedOptions.length === 0 && _jsx("div", _extends({
      className: "dropdown__with__button__options"
    }, {
      children: "No saved filters found"
    }))]
  }));
}
export default DropdownFilter;